/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_SubInputs */

const en_mk_publish_sub = /** @type {(inputs: Mk_Publish_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For automatic projects, previews, readiness checks, and release versions are part of one workflow.`)
};

const id_mk_publish_sub = /** @type {(inputs: Mk_Publish_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk proyek mode otomatis, pratinjau, pemeriksaan kesiapan, dan versi penerbitan ada dalam satu alur.`)
};

/**
* | output |
* | --- |
* | "For automatic projects, previews, readiness checks, and release versions are part of one workflow." |
*
* @param {Mk_Publish_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_sub = /** @type {((inputs?: Mk_Publish_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_sub(inputs)
	return en_mk_publish_sub(inputs)
});